import { render, staticRenderFns } from "./RunnitFaqs.vue?vue&type=template&id=35e1ea67&scoped=true"
import script from "./RunnitFaqs.vue?vue&type=script&lang=ts"
export * from "./RunnitFaqs.vue?vue&type=script&lang=ts"
import style0 from "./RunnitFaqs.vue?vue&type=style&index=0&id=35e1ea67&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35e1ea67",
  null
  
)

export default component.exports